// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var Scalars = require("../scalars/Scalars.bs.js");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {"__root":{"startDateV2":{"c":"Scalars.PlainDateTime"},"endDateV2":{"c":"Scalars.PlainDateTime"}}};

var fragmentConverterMap = {
  "Scalars.PlainDateTime": Scalars.PlainDateTime.parse
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function showingTypeV5_decode($$enum) {
  if ($$enum === "BUYERS_WELCOME" || $$enum === "AGENTS_ONLY" || $$enum === "TAN_ONLY") {
    return $$enum;
  }
  
}

function showingTypeV5_fromString(str) {
  return showingTypeV5_decode(str);
}

var Utils = {
  showingTypeV5_decode: showingTypeV5_decode,
  showingTypeV5_fromString: showingTypeV5_fromString
};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyPageShowingsList_showing",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startDateV2",
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endDateV2",
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "type_",
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notes",
      "storageKey": null
    }
  ],
  "type": "ShowingV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* Scalars Not a pure module */
